module.exports = __webpack_public_path__ + "img/cogwheel.54809ab9.svg";